/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const VIEW_CHECK_ALLOCATION_DETAILS = 'VIEW_CHECK_ALLOCATION_DETAILS';
export const VIEW_CHECK_ALLOCATION_TAB_DATA = 'VIEW_CHECK_ALLOCATION_TAB_DATA';
export const GET_QUARTER_GRID_DATA = 'GET_QUARTER_GRID_DATA';
export const GET_CHECK_DETAILS = 'GET_CHECK_DETAILS';
export const QTR_VALUE = 'QTR_VALUE';
export const GET_INVOICE_GRID = 'GET_INVOICE_GRID';
export const GET_INVOICE_QuarterData = 'GET_INVOICE_QuarterData';
export const ROW_SELECTED = 'ROW_SELECTED';
export const CLEAR_REDUX = 'CLEAR_REDUX';
export const ROSI_PQAS_IS_IDBL_MFG_UB = 'ROSI_PQAS_IS_IDBL_MFG_UB';
export const ACTIVE_ROSI_PQAS_TAB_DETAILS ='ACTIVE_ROSI_PQAS_TAB_DETAILS'
